import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { User } from 'src/app/shared/models/security/user';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class NotificationEmailService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllNotificationEmail(): Observable<NotificationEmail[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.notificationEmailUrl}/all`,
			'getAllNotificationEmail'
		);
	}

	importNotificationEmail(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'notificationEmail.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.notificationEmailUrl}/import`,
			`importNotificationEmail`,
			formData
		);
	}

	getNotificationEmailById(id: number): Observable<NotificationEmail> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.notificationEmailUrl}/get/${id}`,
			'getNotificationEmailById'
		);
	}

	updateNotificationEmail(notificationEmail: NotificationEmail): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.notificationEmailUrl}/update/${notificationEmail.id}`,
			'updateNotificationEmail',
			notificationEmail
		);
	}

	addNotificationEmail(notificationEmail: NotificationEmail): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.notificationEmailUrl}/add`,
			'addNotificationEmail',
			notificationEmail
		);
	}

	deleteNotificationEmail(notificationEmailId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.notificationEmailUrl}/delete/${notificationEmailId}`,
			`deleteNotificationEmail`
		);
	}

	sendEmail(sendEmail: SendEmail): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.notificationEmailUrl}/sendEmail`,
			'sendEmail',
			sendEmail
		);
	}
}
